import { render, staticRenderFns } from "./Scrolltotop.vue?vue&type=template&id=cde83fd0&scoped=true"
import script from "./Scrolltotop.vue?vue&type=script&lang=js"
export * from "./Scrolltotop.vue?vue&type=script&lang=js"
import style0 from "./Scrolltotop.vue?vue&type=style&index=0&id=cde83fd0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde83fd0",
  null
  
)

export default component.exports